<template>
  <section>
    <div class="modal__body">
      <div class="h5">Error de ubicación</div>
      <div class="h6 mt-4">{{ params.mensaje }}</div>
      <div class="h6 mt-4">¿Desea continuar sin ubicación?</div>
    </div>
    <div class="modal__footer">
      <button type="button" class="boton boton--cancelar" @click="hideModal"/>
      <button type="button" class="boton boton--primario" @click="continuar">
        <i class="fa fal fa-check"/>
        <span class="text">Continuar</span>
      </button>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    params() {
      return this.$store.state.modal.params;
    },
  },
  methods: {
    hideModal() {
      return this.$store.commit(this.$actions.hideModal);
    },
    continuar() {
      this.params.continuar();
      this.hideModal();
    },
  },
};
</script>

<style>
.mt-4 {
  margin-top: 16px;
}
</style>
